
import {skills_levels} from './constants'


export const polarChartData = (value, arr_idx, theta, skill_codes,skill_types) => {
    // let r_array = Array(theta.length).fill(0);
    
    // if(r_array.length<4){
    //     let add_length= 4- r_array.length
    //     r_array = r_array.concat( Array(add_length).fill(0) ) 
    // }

    let r=[skills_levels[0].id]
    // r_array.map((e,idx)=>{
    //     if(idx==arr_idx){
    //         e=skills_levels[0].id
    //     }
    //     return e
    // })

    let obj={
        type: 'barpolar',
        r,
        interest:0,
        skill_id: skill_codes,
        skill_type: skill_types,
        theta,
        fill: 'toself',
        name: skills_levels[0].name,
        competency_id: skills_levels[0].id,
        }
        return obj
}


export const changeSkillCompetency = () =>{

}



// export const old_polarChartData = (value, arr_idx, theta) => {
//     let r_array = Array(theta.length).fill(0);
    
//     if(r_array.length<4){
//         let add_length= 4- r_array.length
//         r_array = r_array.concat( Array(add_length).fill(0) ) 
//     }

//     let r = r_array.map((e,idx)=>{
//         if(idx==arr_idx){
//             e=skills_levels[0].id
//         }
//         return e
//     })

//     let obj={
//         type: 'barpolar',
//         r,
//         skill_id: value.code,
//         skill_type: value.type,
//         theta,
//         fill: 'toself',
//         name: skills_levels[0].name,
//         competency_id: skills_levels[0].id,
//         }
//         return obj
// }
